import { Component } from '@angular/core';

@Component({
	template: `<div class="jumbotron bg-transparent text-white text-center">
	<h1 class="display-3">404</h1>
	<p class="lead">Woops. Looks like this page doesn't exist</p>
	<hr class="my-4">
	<a class="btn btn-primary btn-lg" href="/" role="button">Back to home</a>
	</div>`
})
export class PageNotFoundComponent {}



// WEBPACK FOOTER //
// D:/wamp/www/sportal/pmi/web/src/app/not-found.component.ts